import { connect } from 'react-redux'

import RegisterWidgetLayoutTwo from 'components/hub-page/views/sections/register-widget/layouts/two'

const mapStateToProps = (state, ownProps) => ({
  data: state.hubPageRevision.revision.sections[ownProps.sectionId].data[0],
  meta: state.hubPageRevision.revision.sections[ownProps.sectionId].meta,
  theme: state.hubPageRevision.revision.sections[ownProps.sectionId].theme,
  dataTestId: 'participant-hubs-views-register-widget-section-layout-two'
})

export default connect(mapStateToProps)(RegisterWidgetLayoutTwo)
